// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__7MJzX","gfeWrapper":"CalendarEvent_gfeWrapper__3150g"};